import { Component, Input } from "@angular/core";
import { MemorialService } from "administrativo-lib";
import { BaseResourceRptComponent, Coluna, Licitacao, LicitacaoPipe, Memorial } from "eddydata-lib";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-memorial-rpt',
  templateUrl: './memorial-rpt.component.html'
})
export class MemorialRptComponent extends BaseResourceRptComponent {

  @Input() public licitacao: Licitacao;

  constructor(
    private memorialService: MemorialService
  ) {
    super();
  }

  protected afterInit(): void {
  }

  protected tituloRelatorio(): string {
    return `Memorial Descritivo - ${new LicitacaoPipe().transform(this.licitacao.numero)}`;
  }

  protected obterColunasRelatorio(): Coluna[] {
    const retorno: Coluna[] = [];
    retorno.push({ titulo: 'Ordem', coluna: 'ordem', lineHeight: 2, alignment: 'center' });
    retorno.push({ titulo: 'Item', coluna: 'item' });
    retorno.push({ titulo: 'Qtde.', coluna: 'qtde', decimais: 0, alignment: 'center' });
    retorno.push({ titulo: 'Valor Unit.', coluna: 'valor' });
    retorno.push({ titulo: 'Valor Total', coluna: 'total' });

    return retorno;
  }

  protected larguraColunas(): (string | number)[] {
    return ['auto', '*', 'auto', 70, 70];
  }

  protected totalizarColunas(): (string | {})[] {
    return undefined;
  }

  protected carregarLista(): Promise<any[]> {
    return new Promise((resolve) => {
      const lista: {
        ordem: number,
        item: string,
        qtde: number,
        valor: string,
        total: string,
      }[] = [];
      this.memorialService.obterPorLicitacao(this.licitacao.id).pipe(takeUntil(this.unsubscribe))
        .subscribe(async (res) => {
          const reg: Memorial[] = res.content;
          reg.forEach(m => {
            lista.push({
              ordem: m.ordem,
              item: `${m.descricao} ${m.unidade}`,
              qtde: m.quantidade,
              valor: '',
              total: '',
            })
          });

          resolve(lista);
        });
    })
  }

  protected layout(): {} {
    return {
      hLineWidth() {
        return 1;
      },
      vLineWidth() {
        return 1;
      },
      hLineColor(i) {
        return i === 1 || i === 0 ? 'black' : '#aaa';
      },
      paddingLeft(i) {
        return i === 0 ? 0 : 3;
      },
      paddingRight(i, node) {
        return (i === node.table.widths.length - 1) ? 0 : 3;
      }
    }
  }

}